<template>
    <el-dialog
            :visible="isVisible"
            @close="hide"
            :title="title"
            :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <audio-form
                v-if="isInitialized"
                v-bind="formData"
                @stored="onStored"
        ></audio-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import AudioForm from '../../components/audio/form';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      AudioForm,
    },

    computed: {
      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (_.get(this.formData, 'model.id')) {
          return 'Edit Audio'
        }

        return 'Create Audio'
      },
    },
    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-audio-table');
      },
    },

    created() {
      eventBus.$on('show-add-audio-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-add-audio-dialog', this.show);
    }
  }
</script>
